import React from 'react'
import useStyles from './not-found.style'

const NotFound = () => {
  const classes = useStyles()
  return (

    <section
      className={classes.section}
    >
      <div className={classes.container}>
        <div className={classes.columns}>
          <div className={classes.column}>
            <h1 className={classes.title}>Sorry, this page isn't available</h1>
            <p className={classes.subTitle}>The link you have may be broken, we're unable to find the resource you're looking for.</p>
            <img
              alt='logo'
              src='https://bmdev.omnilert.net/admin/images/omnilert_mini_2.png'
            />
          </div>
        </div>
      </div>
    </section>

  )
}

export default NotFound
